export default "<div class='playlist-content' [@fade]=\"visualState\">\n    <ng-template appPlaylistInsert></ng-template>\n</div>"